



































import Vue from "vue";

import BookList from "./components/BookList.vue";
import LookupForm from "./components/LookupForm.vue";
import GoodreadsShelf from "./components/GoodreadsShelf.vue";

import { QueryState, readShelf, searchCatalog } from "./api";
import { FormData } from "./types/forms";
import { Book as GoodreadsBook } from "./types/goodreads";
import { Library, Book as BiblioCommonsBook } from "./types/bibliocommons";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

type Data = {
  readShelfState: QueryState;
  shelfIsCached: boolean;
  shelfCachedTimestamp: number | null;
  searchCatalogState: QueryState;
  goodreadsBooks: GoodreadsBook[];
  biblioCommonsBooks: BiblioCommonsBook[];
  searchedLibrary: Library | null;
};

export default Vue.extend({
  name: "App",
  components: {
    GoodreadsShelf,
    LookupForm,
    BookList
  },
  data(): Data {
    return {
      readShelfState: QueryState.NOT_STARTED,
      shelfIsCached: false,
      shelfCachedTimestamp: null,
      searchCatalogState: QueryState.NOT_STARTED,
      biblioCommonsBooks: [],
      goodreadsBooks: [],
      searchedLibrary: null
    };
  },
  computed: {
    commitLink(): string {
      return `https://github.com/DavidCain/bibliophile-frontend/commit/${this.gitCommitHash}`;
    },
    gitCommitHash(): string {
      return process.env.GIT_COMMIT_HASH.slice(0, 8);
    }
  },
  methods: {
    async onSubmit(form: FormData) {
      this.searchedLibrary = form.library;

      this.readShelfState = QueryState.IN_PROGRESS;
      const { books, isReadFromCache, cachedTimestamp } = await readShelf({
        userId: form.userId,
        shelf: form.shelf,
        skipCache: false
      });
      this.shelfIsCached = isReadFromCache;
      this.shelfCachedTimestamp = cachedTimestamp;
      this.readShelfState = QueryState.COMPLETED;
      books.sort((a: GoodreadsBook, b: GoodreadsBook) =>
        a.title.localeCompare(b.title)
      );
      this.goodreadsBooks = books;

      this.searchCatalog(
        form.library.subdomain,
        form.branch?.name || null,
        books
      );
    },
    async searchCatalog(
      biblioSubdomain: string,
      branch: string | null,
      goodreadsBooks: GoodreadsBook[]
    ) {
      const bookDescriptions = goodreadsBooks.map(bk => ({
        isbn: bk.isbn,
        title: bk.title,
        author: bk.author
      }));

      // Clear out any books left from the last search
      this.biblioCommonsBooks = [];

      if (!bookDescriptions.length) {
        this.searchCatalogState = QueryState.NOT_STARTED;
        return;
      }

      this.searchCatalogState = QueryState.IN_PROGRESS;
      const books: BiblioCommonsBook[] = await searchCatalog({
        // eslint-disable-next-line @typescript-eslint/camelcase
        biblio_subdomain: biblioSubdomain,
        books: bookDescriptions,
        branch
      });
      this.searchCatalogState = QueryState.COMPLETED;
      books.sort((a: BiblioCommonsBook, b: BiblioCommonsBook) =>
        a.title.localeCompare(b.title)
      );
      this.biblioCommonsBooks = books;
    }
  }
});
